import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-image': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM80 416v-64l39.5-39.5c4.7-4.7 12.3-4.7 17 0l39.5 39.5 87.5-87.5c4.7-4.7 12.3-4.7 17 0l23.5 23.5v128h-224zM128 176c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-image.js
// module id = 1733
// module chunks = 0